import React from 'react';
import QuestionGuideView from './QuestionGuideView';
import QuestionDetailView from './QuestionDetailView';
import { ExamPart, ExamPartQuestion } from '../../../model/response';

interface ExamPartViewProps {
  examPart: ExamPart;
  scrollToQuestion?: (questionElement: HTMLDivElement) => void;
  showGuide?: boolean;
  examPartQuestionIndexMap: Map<string, number>;
  firstExamPartQuestionId: string | null;
}

function ExamPartView({
  examPart,
  scrollToQuestion,
  showGuide,
  firstExamPartQuestionId,
  examPartQuestionIndexMap,
}: ExamPartViewProps) {
  const parentQuestions = examPart.examPartQuestions
    .filter((q) => !q.question.parent || !q.question.parent.id)
    .sort((q1, q2) => q1.examPartQuestionIndex - q2.examPartQuestionIndex);

  const getChildren = (parent: ExamPartQuestion) => {
    if (parent.question.type !== 'GROUPED_QUESTION') {
      return [];
    }
    return examPart.examPartQuestions
      .filter((q) => q.question.parent && q.question.parent.id === parent.question.id)
      .sort((q1, q2) => q1.examPartQuestionIndex - q2.examPartQuestionIndex);
  };

  return (
    <div>
      <h4 className={'mb-4 text-[16px] font-medium'}>{examPart.name}</h4>
      <div className={'flex flex-col gap-y-4'}>
        {parentQuestions.map((examPartQuestion) =>
          showGuide ? (
            <QuestionGuideView
              scrollToQuestion={scrollToQuestion}
              examPartQuestion={examPartQuestion}
              children={getChildren(examPartQuestion)}
              key={examPartQuestion.id}
              firstExamPartQuestionId={firstExamPartQuestionId}
              examPartQuestionIndexMap={examPartQuestionIndexMap}
            />
          ) : (
            <QuestionDetailView
              scrollToQuestion={scrollToQuestion}
              examPartQuestion={examPartQuestion}
              children={getChildren(examPartQuestion)}
              key={examPartQuestion.id}
              examPartQuestionIndexMap={examPartQuestionIndexMap}
            />
          ),
        )}
      </div>
    </div>
  );
}

export default ExamPartView;
